/* Desayunos del Cielo · product gallery (scroll-snap carousel, no dependencies). */
if (!customElements.get('ddc-product-gallery')) {
  customElements.define(
    'ddc-product-gallery',
    class DdcProductGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pg-track]');
        this.slides = Array.from(this.querySelectorAll('[data-pg-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-pg-thumb]'));
        this.prev = this.querySelector('[data-pg-prev]');
        this.next = this.querySelector('[data-pg-next]');
        this.current = this.querySelector('[data-pg-current]');
        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
        this.next?.addEventListener('click', () => this.goTo(this.index + 1));
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.pgThumb)));
        });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index - 1);
          }
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = this.slides.indexOf(entry.target);
                this.hydrateSlide(index);
                if (entry.intersectionRatio < 0.6) return;
                this.setActive(this.slides.indexOf(entry.target));
              }
            });
          },
          { root: this.track, threshold: [0.01, 0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
        this.classList.add('is-enhanced');
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      goTo(target) {
        const index = Math.max(0, Math.min(this.slides.length - 1, target));
        this.hydrateAround(index);
        this.track.scrollTo({
          left: index * this.track.clientWidth,
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
        });
        this.setActive(index);
      }

      hydrateSlide(index) {
        const image = this.slides[index]?.querySelector('img[data-src]');
        if (!image) return;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
      }

      hydrateAround(index) {
        this.hydrateSlide(index - 1);
        this.hydrateSlide(index);
        this.hydrateSlide(index + 1);
      }

      setActive(index) {
        if (index < 0 || index === this.index) {
          this.updateControls();
          return;
        }
        this.index = index;
        this.updateControls();
      }

      updateControls() {
        const last = this.slides.length - 1;
        if (this.prev) this.prev.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === last;
        if (this.current) this.current.textContent = String(this.index + 1);
        this.thumbs.forEach((thumb, i) => {
          if (i === this.index) {
            thumb.setAttribute('aria-current', 'true');
            const list = thumb.closest('[data-pg-thumbs]');
            if (list && list.scrollWidth > list.clientWidth + 1) {
              const item = thumb.parentElement || thumb;
              list.scrollTo({ left: item.offsetLeft - list.clientWidth / 2 + item.clientWidth / 2 });
            }
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
